function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M15 8a7 7 0 1 0-4.807 6.65 1 1 0 0 0-.626-1.9A5 5 0 1 1 13 8a1 1 0 0 0 2 0z"
}, React.createElement("animateTransform", {
  attributeType: "xml",
  attributeName: "transform",
  type: "rotate",
  from: "0 8 8",
  to: "360 8 8",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/button-loading.bf029adb.svg";
export { SvgComponent as ReactComponent };